import React from 'react';
import DashboardLayout from '../layouts/DashboardLayout';
import '../styles/help.scss';

function Help() {
  return (
    <DashboardLayout>
      <div className="help-page">
        <iframe
          title="帮助教程"
          src="https://www.yuque.com/zuhaobaobiao/cule88/svci6gmpv0ir2p4q?singleDoc#"
          className="help-iframe"
          allowFullScreen
        />
      </div>
    </DashboardLayout>
  );
}

export default Help;
